import qs from 'qs';

import * as gtm from 'tradera-apps/discover/helpers/search-gtm';
import gtmCore from 'core/script/app/ui/google-tagmanager-service';
import { logger } from 'packages';

import { getSearchResults } from './api';
import actionTypes from './action-types';
import itemActions from '../items/actions';
import pageActions from '../page/actions';
import adsActions from '../ads/actions';
import { API_ERRORS } from 'utils/api';
import { reload } from 'tradera-utils/location';

const requestSearchResults = payload => ({
    type: actionTypes.REQUEST_SEARCH_RESULTS,
    payload
});

/**
 *
 * @param {object} payload the normalized version of the response
 */
const receiveSearchResults = payload => (dispatch, getState) => {
    const {
        result: {
            categoryPath,
            fallbackItems,
            items,
            itemsOnDisplay,
            reduxContainer
        },
        queryParams
    } = payload;
    const { ads, pageMeta } = reduxContainer;
    dispatch(pageActions.setCategoryPath(categoryPath));
    dispatch(pageActions.setPageMeta(pageMeta));
    dispatch(adsActions.setAds(ads));

    gtm.trackPageView(categoryPath, items, pageMeta ? pageMeta.metaTitle : '');
    const { page: pageStore } = getState();
    if (pageStore.type === 'SearchResults') {
        gtmCore.trackGtmEvent('search', {
            searchQuery: queryParams.q,
            itemIds: items.map(item => item.itemId)
        });
    }

    if (fallbackItems) {
        dispatch(itemActions.add(fallbackItems));
    }

    if (itemsOnDisplay) {
        const itemsWithOnDisplay = [...items];
        itemsWithOnDisplay.push(...itemsOnDisplay.items);
        dispatch(itemActions.add(itemsWithOnDisplay));
    } else if (items) {
        dispatch(itemActions.add(items));
    }

    return dispatch({
        type: actionTypes.RECEIVE_SEARCH_RESULTS,
        payload
    });
};

const fetchSearchResults = (endpoint, queryParams) => {
    return async (dispatch, getState) => {
        dispatch(requestSearchResults());
        if (document.getElementById('bread-crumbs')) {
            document.getElementById('bread-crumbs').scrollIntoView();
        } else {
            window.scrollTo(0, 0);
        }
        const {
            environment: { version }
        } = getState();
        return getSearchResults(endpoint, queryParams, '', version)
            .then(({ data: result }) => {
                const searchResults = { result, queryParams };
                dispatch(receiveSearchResults(searchResults));
                return searchResults;
            })
            .catch(error => {
                switch (error.message) {
                    case API_ERRORS.CANCELLED:
                        break;
                    case API_ERRORS.VERSION_MISMATCH:
                        reload(true);
                        break;
                    default:
                        dispatch(handleSearchResultsError(error));
                        break;
                }
                switch (error.message) {
                    case API_ERRORS.CANCELLED:
                    case API_ERRORS.NETWORK:
                    case API_ERRORS.TIMEOUT:
                    case API_ERRORS.VERSION_MISMATCH:
                        break;
                    default:
                        logger(error);
                        break;
                }
            });
    };
};

const handleSearchResultsError = payload => ({
    type: actionTypes.HANDLE_SEARCH_RESULTS_ERROR,
    payload
});

const updateRouting = payload => ({
    type: actionTypes.UPDATE_ROUTING,
    payload
});

const historyLocationDidUpdate = history => (dispatch, getState) => {
    const routingState = getState().search.routing;
    const isPrevAndCurrentPathnameEqual = () => {
        return (
            routingState &&
            routingState.location.search === history.location.search &&
            routingState.location.pathname === history.location.pathname
        );
    };

    if (history.action === 'POP' && !isPrevAndCurrentPathnameEqual()) {
        dispatch(
            fetchSearchResults(
                location.pathname,
                qs.parse(history.location.search.substring(1))
            )
        );
    } else if (history.action === 'PUSH' && !isPrevAndCurrentPathnameEqual()) {
        dispatch(
            fetchSearchResults(
                location.pathname,
                qs.parse(history.location.search.substring(1))
            )
        );
    }
    dispatch(updateRouting(history));
};

const setSingleFilterValue = (filter, value) => {
    return {
        type: actionTypes.SET_SINGLE_FILTER,
        payload: {
            filter,
            value
        }
    };
};

const setActiveCategory = payload => ({
    type: actionTypes.SET_ACTIVE_CATEGORY,
    payload
});

const addItemOnDisplay = payload => ({
    type: actionTypes.ADD_ITEM_ON_DISPLAY,
    payload
});

const removeItemOnDisplay = payload => ({
    type: actionTypes.REMOVE_ITEM_ON_DISPLAY,
    payload
});

export default {
    fetchSearchResults,
    requestSearchResults,
    receiveSearchResults,
    historyLocationDidUpdate,
    updateRouting,
    setSingleFilterValue,
    setActiveCategory,
    addItemOnDisplay,
    removeItemOnDisplay
};
